"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeLines = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const range_1 = __importDefault(require("lodash/range"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = (config, extend, narrow) => {
    const w = narrow ? 8 : 12;
    const w2 = w * 2;
    const wMinus1 = w - 1;
    const w2Plus1 = w2 + 1;
    const horiz = {
        content: '""',
        display: 'block',
        minWidth: wMinus1,
        maxWidth: wMinus1,
    };
    const line = {
        float: 'left',
        height: '100%',
        minWidth: w,
        maxWidth: w,
        marginLeft: w,
        marginRight: 0,
        color: lib_palette_1.default.LineGrey.main,
    };
    return {
        root: {
            position: 'relative',
            height: '100%',
        },
        space: {
            float: 'left',
            height: '100%',
            minWidth: w2,
            maxWidth: w2,
        },
        lineRoot: Object.assign(Object.assign({}, line), { marginLeft: ((config === null || config === void 0 ? void 0 : config.length) || 0) * w2, left: w, position: 'absolute', '&::before': Object.assign(Object.assign({}, horiz), { height: '70%' }), '&::after': Object.assign(Object.assign({}, horiz), { height: '30%', borderLeft: '1px solid' }) }),
        fullLine: Object.assign(Object.assign({}, line), { borderLeft: '1px solid' }),
        leaf: Object.assign(Object.assign({}, line), { '&::before': Object.assign(Object.assign({}, horiz), { borderLeft: '1px solid', position: 'relative', height: `calc(50% + ${extend}px)`, top: -extend }), '&::after': Object.assign(Object.assign({}, horiz), { position: 'relative', height: `calc(50% + ${extend}px)`, top: -extend, borderTop: '1px solid', borderLeft: '1px solid' }) }),
        lastLeaf: Object.assign(Object.assign({}, line), { '&::before': Object.assign(Object.assign({}, horiz), { position: 'relative', height: `calc(50% + ${extend}px)`, top: -extend, borderLeft: '1px solid', borderBottom: '1px solid' }), '&::after': Object.assign(Object.assign({}, horiz), { minWidth: w2Plus1, maxWidth: w2Plus1, position: 'relative', height: `calc(50% + ${extend}px)`, top: -extend }) }),
    };
};
exports.TreeLines = react_1.default.memo((props) => {
    const { showLineBelow = false, config, extend = 0, narrow = false } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [config, extend, narrow]);
    return (react_1.default.createElement("div", { className: myCss.root + ' treeLines' },
        showLineBelow && react_1.default.createElement("div", { className: myCss.lineRoot }),
        (0, range_1.default)(config.length).map(i => {
            const isLast = config[i];
            const isLeaf = i === config.length - 1;
            let className;
            if (isLeaf && isLast) {
                className = myCss.lastLeaf;
            }
            else if (isLeaf && !isLast) {
                className = myCss.leaf;
            }
            else if (!isLeaf && isLast) {
                className = myCss.space;
            }
            else {
                className = myCss.fullLine;
            }
            return react_1.default.createElement("div", { key: 'line' + i, className: className });
        })));
});
exports.default = exports.TreeLines;
